import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const LoadTimeChartComponent = ({ data, options }) => {
  return (
    <div style={{ background: "#fff", padding: "20px", borderRadius: "12px" }}>
      <h3>Load Time</h3>
      <div style={{ background: "#f5f5f5", borderRadius: "8px", padding: "4px", marginBottom: "10px", width: "118px"}}>
        <button style={{
          padding: "6px 12px",
          border: "none",
          background: "#ffffff",
          borderRadius: "6px",
          marginRight: "4px",
          cursor: "pointer",
          fontSize: "14px",
          fontWeight: 500,
        }}>Sec</button>
        <button style={{
          padding: "6px 12px",
          border: "none",
          background: "transparent",
          cursor: "pointer",
          fontSize: "14px",
          fontWeight: 500,
        }}>Min</button>
      </div>
      <Bar data={data} options={options} />
    </div>
  );
};

export default LoadTimeChartComponent;
